import type { FC } from 'react'

import { Minus, Plus } from 'lucide-react'
import { cn } from '@/lib/utils'
import { formatNumber } from '@/lib/format'

import { ORDER_RULES } from '@/constants/site'

interface QuantityStepperProps {
    value: number
    onChange: (value: number) => void
    label: string
    min?: number
    max?: number
    size?: 'sm' | 'md'
    className?: string
}

export const QuantityStepper: FC<QuantityStepperProps> = ({ value, onChange, label, min = 0, max = ORDER_RULES.maxQuantityPerItem, size = 'md', className }) => {
    const box = size === 'sm' ? 'size-9' : 'size-11'

    return (
        <div className={cn('inline-flex items-center rounded-sm border border-line-strong bg-background', className)} role='group' aria-label={`تعداد ${label}`}>
            <button
                type='button'
                className={cn(box, 'inline-flex cursor-pointer items-center justify-center text-foreground transition-colors duration-300 hover:bg-flour-deep focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-amber disabled:cursor-not-allowed disabled:text-line-strong disabled:hover:bg-transparent')}
                onClick={() => onChange(Math.max(min, value - 1))}
                disabled={value <= min}
                aria-label={`یک ${label} کمتر`}
            >
                <Minus className='size-4' aria-hidden='true' />
            </button>

            <span className={cn('min-w-8 text-center text-sm font-medium tabular-nums', size === 'sm' && 'min-w-7')} aria-live='polite'>
                {formatNumber(value)}
            </span>

            <button
                type='button'
                className={cn(box, 'inline-flex cursor-pointer items-center justify-center text-foreground transition-colors duration-300 hover:bg-flour-deep focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-amber disabled:cursor-not-allowed disabled:text-line-strong disabled:hover:bg-transparent')}
                onClick={() => onChange(Math.min(max, value + 1))}
                disabled={value >= max}
                aria-label={`یک ${label} بیشتر`}
            >
                <Plus className='size-4' aria-hidden='true' />
            </button>
        </div>
    )
}
